<template>
  <div class="inps">
    <div
      class="inps-list"
      :class="{ third: index === 2 }"
      v-for="(item, index) in inps"
      :key="index"
      @click="isClick = true"
    >
      <InputNumber
        :id="`inp${index}`"
        v-model:value.number="item.value"
        :maxlength="1"
        :controls="false"
        @focus="handleFocus(index)"
        @input="handleChange"
        @keyup.delete="handleDelete"
      ></InputNumber>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { onMounted, ref } from 'vue'
  import { InputNumber } from 'ant-design-vue'
  const inps = ref(
    Array.from({ length: 6 }, () => ({
      value: ''
    }))
  )
  const currIndex = ref(0)
  const emits = defineEmits(['update:authCode'])
  const handleChange = (e: any) => {
    emits('update:authCode', inps.value.map((_) => _.value).join(''))
    if (currIndex.value === 5 && e) getElement(currIndex.value).blur()
    if (currIndex.value === 5 || !e || isNaN(Number(e))) return
    currIndex.value++
    setElementFocus()
  }
  const handleDelete = (e: any) => {
    if (currIndex.value === 0 || e.target.value.length) return
    /**点击后第一次删除值不跳到上一个输入框,第二次删除空跳转上个输入框 */
    if (isClick.value) return (isClick.value = false)
    currIndex.value--
    setElementFocus()
  }
  const handleFocus = (i: number) => {
    currIndex.value = i
    getElement(i).select()
  }

  /**用于记录输入框被点击 */
  const isClick = ref(false)

  const getElement = (i: number): any => document.querySelector(`#inp${i}`)
  const setElementFocus = () => {
    const value = getElement(currIndex.value)
    value.focus()
  }
  onMounted(() => {
    setElementFocus()
  })
</script>

<style lang="less" scoped>
  .inps {
    .flex;
    &-list {
      width: 46px;
      height: 46px;
      .mr(14px);
      &:last-of-type {
        .mr(0);
      }
      &.third {
        margin-right: 61px;
        position: relative;
      }
      &::after {
        display: block;
        content: '';
        width: 14px;
        height: 1px;
        background-color: @text-color1;
        position: absolute;
        top: 22.5px;
        right: -36px;
      }
      .ant-input-number,
      :deep(.ant-input-number-input-wrap),
      :deep(input) {
        width: 100%;
        height: 100%;
        text-align: center;
        .fs-18;
        .f-bold;
      }
    }
  }
</style>
